export const EXPERIENCES = [
    {
        name: "University of Virginia",
        date: "Current",
        position: "Teaching Assistant",
        location: "Charlotsville, Virginia",
        points: [
            "Collaboration with the professor to improve course material and improve grading automation.",
            
        ]
    },
    {
        name: "ZOOM",
        date: "2022-2023",
        position: "Full Stack Developer",
        location: "Remote",
        points: [

            "Led development of secure third-party data ingestion app with a team of 4 devs.",
            "Optimized API usage for cost-effective identification of harmful content on Zoom.",
            "Collaborated on front-end dev using React, Redux, selectors, and thunks for a seamless law enforcement site.",
            "Updated vulnerable packages and identified code vulnerabilities as security champion."
        ]
    },
    {
        name: "EBAY",
        date: "2021",
        position: "SWE Intern",
        location: "Remote",
        points: [
            "Designed and developed a consumer app for detecting breaks in payment processing.",
            "Managed processing of 120M+ daily events in a distributed system, ensuring accurate payment processing.",
            "Reduced support response time for payment-related requests by more than 10 hours a week.",
            "Utilized Kafka for detecting and addressing payment issues and monitoring error rates."
        ]
    },
    {
        name: "UCSB",
        date: "2019-2020",
        position: "Undergraduate Assistant",
        location: "Santa Barbara, California",
        points: [
            "Appointed as Course Lead, managed team of 10+ tutors, and developed learning resources to improve academic performance.",
            "Designed lab assignments and practice problems to enhance student engagement and retention rates.",
            "Conducted tutoring sessions, workshops, and office hours to assist students with course material and projects."
        ]
    },


];